import React, {useMemo} from "react";
import {DatabaseCode, isDatabaseCode} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {DefaultTFuncReturn, Namespace, TFunction} from "i18next";
import {DefaultText, DefaultTextProps} from "../DefaultText/DefaultText";

type FormattedDatabaseCodeProps = Omit<DefaultTextProps, 'value'> & {
  value?: DatabaseCode | string
  ns?: Namespace
  style?: React.CSSProperties;
}

export const getFormattedDatabaseCode = (value: DatabaseCode | undefined, t: TFunction): DefaultTFuncReturn | string | undefined => {
  if (typeof value === 'undefined') {
    return undefined
  }

  return t(value.displayValue.id, value.displayValue.defaultMessage)
}

export const FormattedDatabaseCode = (props: FormattedDatabaseCodeProps) => {
  const {value, defaultValue, ns = ["common"], style, ...rest} = props;

  const {t} = useTranslation(ns)

  const displayValue = useMemo(() => {
    if (isDatabaseCode(value)) {
      return getFormattedDatabaseCode(value, t)
    } else if (value) {
      return getFormattedDatabaseCode({
        code: value,
        displayValue: {id: value, defaultMessage: value}
      }, t)
    } else {
      return undefined
    }
  }, [value, t])

  if (!displayValue) {
    if (style) {
      return (
        <span style={style}>
          <DefaultText {...rest} defaultValue={defaultValue}/>
        </span>
      )
    } else {
      return (
        <DefaultText {...rest} defaultValue={defaultValue}/>
      )
    }
  }

  if (style) {
    return (
      <span style={style}>
        {displayValue}
      </span>
    )
  }

  return (
    <>
      {displayValue}
    </>
  )
};
